import { FC } from "react";
import { Stack, Typography } from "@mui/material";

interface DataPieceChipProps {
  title: string;
  data: string;
}

export const DataPieceChip: FC<DataPieceChipProps> = ({ title, data }) => {
  return (
    <Stack
      pl={0.75}
      pr={3}
      py={0.25}
      border={1}
      height={34}
      justifyContent="center"
      borderRadius={1}
      borderColor="grey.400"
    >
      <Typography
        variant="caption"
        fontSize={10}
        color="grey.600"
        lineHeight={1.25}
      >
        {title}
      </Typography>
      <Typography variant="caption" lineHeight={1.25} fontWeight="medium">
        {data}
      </Typography>
    </Stack>
  );
};
